
import { connect } from 'react-redux';
import { actionCreators as draftActionCreators} from 'app/area/case/draft/actions';

export const withSaveAsDraft = (component: any, uiEngineProps: any) => {
  const dispatchToProps = (dispatch: any): Partial<any> => {
    return {
      onSaveAsDraft: async () => {
        await dispatch(draftActionCreators.saveAsDraft());
      }
    };
  };

  return connect<any, any, any>(
    undefined,
    dispatchToProps
  )(component);
};
